import Modal from "../../../../../global/Modal";
import DeleteModal from "../../../../Common/Modals/components/DeleteModal";
import useOtherLiensBalanceDeleteModal from "../../../hooks/useOtherLiensBalanceDeleteModal";

export default function OtherLiensBalanceDeleteModal(props) {
  const { expenseData, openModal, handleCloseModal } = props;
  const { isDeleting, handleDelete } = useOtherLiensBalanceDeleteModal(props);

  if (!expenseData) {
    return null;
  }

  return (
    <Modal open={openModal} onClose={handleCloseModal} maxWidth="xs">
      <div className="flex flex-row items-center justify-center p-2">
        <DeleteModal
          additionalDetails={{
            deleteLabel: "Delete Expense",
            handleCancel: handleCloseModal,
            handleDelete,
            isDeleting,
          }}
        />
      </div>
    </Modal>
  );
}
